import { Card } from "@/components/ui/card";
import { IconBox } from "@common/components";
import { Button } from "@/components/ui/button";
import { ConfirmationDialog } from "@common/components/ConfirmationDialog/ConfirmationDialog";
import { Bank, Trash } from "@phosphor-icons/react";
import { Body } from "@hypercard/web-components";

interface BankAccountItemProps {
  accountName: string;
  subtitle: string;
  isDeleting: boolean;
  onDelete: () => void;
}

const BankAccountItem: React.FC<BankAccountItemProps> = ({
  accountName,
  subtitle,
  isDeleting,
  onDelete,
}) => {
  return (
    <li className="flex">
      <Card className="flex w-full flex-row items-center justify-between p-6">
        <div className="flex items-center">
          <IconBox>
            <Bank className="size-7" />
          </IconBox>
          <div className="ml-3 flex flex-col">
            <Body size="lg" weight="medium">
              {accountName}
            </Body>
            {subtitle && (
              <Body
                size="sm"
                weight="regular"
                className="capitalize text-slate"
              >
                {subtitle}
              </Body>
            )}
          </div>
        </div>
        {onDelete && (
          <ConfirmationDialog
            title="Delete Bank Account?"
            description={`Are you sure you want to delete this bank account?\nThis action cannot be undone.`}
            onConfirm={onDelete}
            disabled={isDeleting}
            confirmText="Delete Bank Account"
          >
            <Button disabled={isDeleting} className="p-1" variant="ghost">
              <Trash className="size-7" />
            </Button>
          </ConfirmationDialog>
        )}
      </Card>
    </li>
  );
};

export default BankAccountItem;
